<template>
  <div class="body">
    <div class="main_container main_full_div" :style="{ backgroundImage: `url(${configObj.landingBgImg})`, backgroundColor: configObj.landingBgImg ? '' : '#7e7877' }">
      <!-- <training-header :appConfig = "configObj"  ></training-header> -->
      <div class="banner-wrap">
        <!-- page content -->
        <div class="text-wrap-center">
          <!-- <h2>Welcome to <span>e-learning</span> course on Family Planning</h2>
          <h4>Discover training and resources to support high-quality family planning services</h4> -->
          <h2>{{configObj.contentHeading}}</h2>
          <h4>{{configObj.contentDescription}}</h4>
        </div>
        <div class="button-wrap">
          <div class="button-div-wrap">
            <!-- <a href="#/facilitator-page" class="btn btn-secondary">  </a> -->
            <router-link :to="{ name: 'facilitator-page', params: { facilitatorObj: frmModel ,appConfig: configObj}}" class="color-white text-decoration-none">
                <span class="fa fa-puzzle-piece pull-left" style="font-size: 20px;padding-right: 15px; color: #65f67f;"></span>training planning
            </router-link>
            <router-link :to="{ name: 'training-agenda', params: { facilitatorObj: frmModel ,appConfig: configObj}}" class="color-white text-decoration-none">
                <span class="fa fa-folder-open pull-left" style="font-size: 20px;padding-right: 15px; color: #e641ff;"></span>training material
            </router-link>
            <!-- <a href="https://avenirtraining.duredemos.com/facilatorpage.html" class="btn btn-secondary"> <span class="fa fa-puzzle-piece pull-left" style="font-size: 20px;padding-right: 15px; color: #65f67f;"></span>training planning </a>
            <a href="https://avenirtraining.duredemos.com/training_agenda_session.html" class="btn btn-secondary"><span class="fa fa-folder-open pull-left" style="font-size: 20px;padding-right: 15px; color: #e641ff;"></span>training material</a> -->
            <router-link :to="{ name: 'exam-id', params: { facilitatorObj: frmModel ,appConfig: configObj }}" class="color-white text-decoration-none">
                <span class="fa fa-file-text-o pull-left" style="font-size: 20px;padding-right: 15px; color: #4cbbf9;"></span>Course Test
            </router-link>
            <router-link :to="{ name: 'certificate-status', params: { facilitatorObj: frmModel ,appConfig: configObj }}" class="color-white text-decoration-none">
              <span class="fa fa-certificate pull-left" style="font-size: 20px;padding-right: 15px; color: #f4db55;"></span>Certificate
            </router-link>
            <router-link :to="{ name: 'training-faq', params: { facilitatorObj: frmModel ,appConfig: configObj }}" class="color-white text-decoration-none">
              <span class="fa fa-certificate pull-left" style="font-size: 20px;padding-right: 15px; color: #f4db55;"></span>FAQ
            </router-link>
          </div>
        </div>

      </div>
      <!-- /page content -->

      <!-- footer content -->
      <!-- <training-footer :appConfig="configObj"></training-footer> -->
      <div class="floating-chat-icon">
        <div class="floatingIcon">
          <span class="fa fa-comments" aria-hidden="true"></span>
        </div>
      </div>
      <!-- /footer content -->
    </div>
  </div>
</template>

<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import ApiServices from '../service/ApiServices';

export default {
  components: {
    trainingHeader,
    trainingFooter
  },
  data() {
    return {
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      frmModel:{},
      configObj:{}
    }
  },
  methods: {
  },
  mounted() {
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl+this.dashboardUrl;
    this.$root.loading = true;
    if(localStorage.getItem("userProfile")){
      this.loggedInUserProfile = JSON.parse(localStorage.getItem("userProfile"));
    //   if(this.$route.params.frmModel){
    //   this.frmModel = this.$route.params.frmModel
    // }
    //   if(this.$route.params.configObj){
    //   this.configObj = this.$route.params.configObj
    //   }
      ApiServices.RestGetCall('/api/avenir/training/getAppDetails',{'userId': this.loggedInUserProfile.username}).then(aveT => {
        console.log(aveT);
        this.avenirTraining=aveT
        if(this.avenirTraining.trainingApp && this.avenirTraining.config && this.avenirTraining.trainingApp !="No training app available"){
          this.$root.loading = false;
          this.frmModel = this.avenirTraining.trainingApp;
          console.log(this.frmModel);
          if(this.frmModel.course.length > 0)
          this.course = this.frmModel.course[0];
          this.configObj = this.avenirTraining.config
          this.configObj.color = "#212832"
        }
        else{
          this.$root.loading = false;
        }
      });
      //this.avenirTraining = JSON.parse(localStorage.getItem("avenirTraining"));
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
